import { DataTable } from "@shopify/polaris";

import { ReasonSummaryTableWrapper } from "../../CancellationReasonsSettings/styles";
import { SummaryTabConfig } from "./types";

export const getReasonSummaryTab = (responseHeader: JSX.Element, config: SummaryTabConfig) => ({
  id: config.id,
  value: (
    <ReasonSummaryTableWrapper>
      <DataTable
        columnContentTypes={["text", "numeric"]}
        headings={["Reasons", responseHeader]}
        rows={config.rows!}
        sortable={[false, false]}
        defaultSortDirection="descending"
        initialSortColumnIndex={4}
      />
    </ReasonSummaryTableWrapper>
  ),
  accessibilityLabel: config.label,
  content: config.label,
});
